import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="row-checkbox"
// Allows for clicking anywhere within a row to toggle the first checkbox within the row
export default class extends Controller {
  static targets = [
    "checkAll",
    "checkbox"
  ]

  static values = {
    identifier: String
  }
  
  clickCheckAll(event) {
    this.checkboxTargets.forEach(el => el.checked = event.target.checked);
  }

  click(event) {
    setTimeout(() => {
      if (this.hasCheckAllTarget) {
          this.checkAllTarget.checked = !this.checkboxTargets.some(e => !e.checked);
      }
    })

    if (event.target.tagName == 'A' || event.target.tagName == 'INPUT' ) {
      return;
    }

    event.preventDefault();
    const el = event.currentTarget.querySelector("input[type=checkbox]")
    el.checked = !el.checked;

    if (this.hasIdentifierValue) {
      this.dispatch("click", {detail: {identifier: this.identifierValue}})
    }
  }
}

